function truncateDecimals(number, digits) {
    const multiplier = Math.pow(10, digits);
    const adjustedNum = number * multiplier;
    const truncatedNum = Math[adjustedNum < 0 ? 'ceil' : 'floor'](adjustedNum);
    return truncatedNum / multiplier;
}

// Custom currency filter for Woolworths
module.exports = function (currencyFilter) {
    return function (amount) {
        const truncatedAmount = truncateDecimals(amount, 2);
        if (typeof amount !== 'undefined' && !(amount > 0)) {
            return 'Free';
        }

        // 0 precision when the amount is less than 1 cent, otherwise 2 decimal places.
        return currencyFilter(truncatedAmount, '$', truncatedAmount < 0.01 ? 0 : 2);
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/wow-currencyfull.js
 **/